import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {AdminsComponent} from './admins/admins.component';
import {UpsertAdminComponent} from './upsert-admin/upsert-admin.component';

@NgModule({
  declarations: [
    AdminsComponent,
    UpsertAdminComponent,
  ],
  imports: [
    CoreModule,
  ],
  exports: [
    AdminsComponent,
    UpsertAdminComponent,
  ],
})
export class AdminModule {
}
